var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 228 228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2,.cls-6{opacity:0.3;}.cls-3{fill:#818181;}.cls-4{stroke:#fff;stroke-width:2px;}.cls-5{clip-path:url(#clip-path);}.cls-6,.cls-7{fill:#fff;}.cls-6{isolation:isolate;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-10.17 -107.82)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77,
    y: 1.36,
    width: 168.97,
    height: 275.95,
    transform: "translate(-37.32 216.59) rotate(-62.03)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 114,
    cy: 114,
    r: 114
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 114,
    cy: 114,
    r: 113
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    className: "cls-6",
    cx: 114,
    cy: 114,
    r: 114
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-7",
    d: "M156.28,276.74H91A12.82,12.82,0,0,1,78.17,264v-39.9A12.82,12.82,0,0,1,91,211.25h1.77v-27.1c0-15,13.83-27.32,30.9-27.32s30.93,12.34,30.93,27.32v27.1h1.77a12.82,12.82,0,0,1,12.8,12.82V264A12.82,12.82,0,0,1,156.28,276.74ZM91,215a9,9,0,0,0-9,9v40a9,9,0,0,0,9,9h65.25a9,9,0,0,0,9-9v-39.9a9,9,0,0,0-8.9-9h-5.62V184.14c0-12.94-12.17-23.47-27.1-23.47S96.51,171.2,96.51,184.14V215Zm47.44,0H108.81l-.53-1.09a10.28,10.28,0,0,1-1.08-4.45V184.14c0-7,7.37-12.8,16.44-12.8s16.41,5.75,16.41,12.8v25.41A10.09,10.09,0,0,1,139,214Zm-27.16-3.84H136a5.62,5.62,0,0,0,.26-1.77V184.14c0-4.94-5.64-9-12.59-9s-12.61,4-12.61,9v25.41a5.43,5.43,0,0,0,.25,1.7Z",
    transform: "translate(-10.17 -107.82)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-7",
    d: "M124.4,263.85h-.07a8.57,8.57,0,0,1-8.53-8.55V252a14.47,14.47,0,1,1,23-11.65A14.28,14.28,0,0,1,132.89,252v3.24a8.55,8.55,0,0,1-8.48,8.6Zm0-36a12.47,12.47,0,0,0-7,22.79l.44.3v4.36a6.56,6.56,0,0,0,6.53,6.54h0v1l0-1a6.54,6.54,0,0,0,6.52-6.57V251l.45-.3a12.28,12.28,0,0,0,5.47-10.3,12.45,12.45,0,0,0-12.43-12.49Z",
    transform: "translate(-10.17 -107.82)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.a646086f.svg";
export { ForwardRef as ReactComponent };